var map = {
	"./DE-vue_components.json": "ed99",
	"./DE-web_content.json": "5fd2",
	"./EN-vue_components.json": "2632",
	"./EN-web_content.json": "d468",
	"./FR-vue_components.json": "c67f",
	"./FR-web_content.json": "e70d",
	"./IT-vue_components.json": "cb01",
	"./IT-web_content.json": "c0db",
	"./NL-vue_components.json": "ca3b",
	"./NL-web_content.json": "4b71"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1e0f";